import { MxposTrade } from '@app/models/mxpostrade';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transactionType'
})
export class TransactionTypePipe implements PipeTransform {

  transform(mxPosTrade: MxposTrade): string {

    let transType: string = "";

    if (mxPosTrade.unitBal > 0) {
      if (mxPosTrade.pendUnits === 0) {
        transType = "Owned";
      } else {
        transType = "Pending Delivery";
      }
    } else if (mxPosTrade.pendUnits === 0) {
      transType = "Commodity Lease";
    } else {
      transType = "Pending Receipt";
    }
    return transType;
  }

}
